import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface InstallConfig {
    consumerDirectInstallUrl: string;
    consumerInstallLink: string;
    commercialMySoftwarePageUrl: string;
    dimeEnabled: boolean;
    dimeJSUrl: string;
    dimeTimeoutMs: number;
    goPremiumUrl: string;
    goPremiumUrlPremiumTemplates: string;
    installApiRoot: string;
    installApiSWEnabled: boolean;
    pwaInstallMoveEnabled: boolean;
    resources: InstallResources;
    sendRequestId: boolean;
    shellGoPremiumUrl: string;
    wizardImageAssets: string;
    wizardSupportLink: string;
    buyOffice365Url: string;
    haveOfficeProductKeyUrl: string;
    needHelpInstallingOfficeUrl: string;
    ecsInstallNoLicenseOptionsEnabled: boolean;
}

export interface InstallResources {
    BuyOffice365BtnText: string;
    GetOfficeAppsButtonAriaLabelAndroid: string;
    GetOfficeAppsButtonAriaLabelIpad: string;
    GetOfficeAppsButtonAriaLabelIphone: string;
    GetOfficeAppsButtonText: string;
    GoPremiumBtnText: string;
    GoPremiumDescription: string;
    HaveOfficeProductKeyLnkText: string;
    InstallAdditionalLinkAriaLabel: string;
    InstallAdditionalLinkDescription: string;
    InstallAdditionalLinkText: string;
    InstallConsumerMyAccountLinkAriaLabel: string;
    InstallDesktopAppsBtnText: string;
    InstallIndividualAppText: string;
    InstallOfficeAppsButtonText: string;
    InstallOfficeButtonAriaLabel: string;
    InstallOfficeButtonText: string;
    InstallOfficeDescription: string;
    InstallOfficeLinkText: string;
    InstallSoftwareButtonText: string;
    InstallText: string;
    InstallWizardCloseButtonAriaLabel: string;
    InstallWizardCloseButtonText: string;
    InstallWizardStep1DescriptionForChrome: string;
    InstallWizardStep1DescriptionForFirefox: string;
    InstallWizardStep1DescriptionForIE: string;
    InstallWizardStep1DescriptionForMac2011: string;
    InstallWizardStep1DescriptionForMac2016: string;
    InstallWizardStep1Title: string;
    InstallWizardStep1TitleForMac: string;
    InstallWizardStep2Description: string;
    InstallWizardStep2DescriptionForMac2011: string;
    InstallWizardStep2DescriptionForMac2016: string;
    InstallWizardStep2Title: string;
    InstallWizardStep2TitleForMac: string;
    InstallWizardStep3Description: string;
    InstallWizardStep3DescriptionForFallbackUrl: string;
    InstallWizardStep3DescriptionForMac2011: string;
    InstallWizardStep3DescriptionForMac2016: string;
    InstallWizardStep3Title: string;
    InstallWizardStep3TitleForFallbackUrl: string;
    InstallWizardStep3TitleForMac: string;
    InstallWizardSupportLinkAriaLabel: string;
    InstallWizardSupportLinkText: string;
    InstallWizardTitle: string;
    NeedHelpInstallingOfficeLnkText: string;
    OfficeBrand2011Short: string;
    OfficeBrand2013Short: string;
    OfficeBrand2016Short: string;
    OfficeBrandShort: string;
    DesktopApp: string;
    TryMicrosoft365BtnText: string;
}

@Injectable({
    providedIn: 'root'
})
export class InstallConfigService {
    public readonly config: InstallConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<InstallConfig>('installConfig') || {
            consumerDirectInstallUrl: '',
            consumerInstallLink: '',
            commercialMySoftwarePageUrl: '',
            dimeEnabled: false,
            dimeJSUrl: '',
            dimeTimeoutMs: 5000,
            goPremiumUrl: '',
            goPremiumUrlPremiumTemplates: '',
            installApiRoot: '',
            installApiSWEnabled: false,
            pwaInstallMoveEnabled: false,
            resources: null,
            sendRequestId: false,
            shellGoPremiumUrl: '',
            wizardImageAssets: '',
            wizardSupportLink: '',
            buyOffice365Url: '',
            haveOfficeProductKeyUrl: '',
            needHelpInstallingOfficeUrl: '',
            ecsInstallNoLicenseOptionsEnabled: false
        };
    }
}
